import { render } from "./GoodReviews.vue?vue&type=template&id=45e56c36&scoped=true"
import script from "./GoodReviews.vue?vue&type=script&lang=js"
export * from "./GoodReviews.vue?vue&type=script&lang=js"

import "./GoodReviews.vue?vue&type=style&index=0&id=45e56c36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e56c36"]])

export default __exports__